import { createSelector } from '@ngrx/store';
import { EntityState, EntitySelectors, Dictionary } from './models';
/**
 * @template T
 * @return {?}
 */
export function createSelectorsFactory<T>() {
  return {
/**
 * @template V
 * @param {?} selectState
 * @return {?}
 */
getSelectors<V>(
      selectState: (state: V) => EntityState<T>
    ): EntitySelectors<T, V> {
      const /** @type {?} */ selectIds = (state: any) => state.ids;
      const /** @type {?} */ selectEntities = (state: EntityState<T>) => state.entities;
      const /** @type {?} */ selectAll = createSelector(
        selectIds,
        selectEntities,
        (ids: T[], entities: Dictionary<T>): any =>
          ids.map((id: any) => ( /** @type {?} */((entities as any)))[id])
      );

      const /** @type {?} */ selectTotal = createSelector(selectIds, ids => ids.length);

      return {
        selectIds: createSelector(selectState, selectIds),
        selectEntities: createSelector(selectState, selectEntities),
        selectAll: createSelector(selectState, selectAll),
        selectTotal: createSelector(selectState, selectTotal),
      };
    },
  };
}



// WEBPACK FOOTER //
// ../../../modules/entity/src/state_selectors.ts